// src/context/AppContext.js

import React, { createContext, useState, useCallback } from 'react';

// 1. Cria o contexto
export const AppContext = createContext();

// 2. Cria o Provedor (Provider) do contexto
export const AppProvider = ({ children }) => {
  // --- DEFINIÇÃO DOS ESTADOS ---

  // ✅ CORREÇÃO CRÍTICA: O estado 'cart' é iniciado com um array vazio [].
  // Isso resolve o erro "Cannot read properties of undefined (reading 'some')".
  const [cart, setCart] = useState([]);

  const [vehicleQuery, setVehicleQuery] = useState(null);

  // --- FUNÇÕES PARA MANIPULAR O ESTADO ---

  const addToCart = useCallback((itemToAdd) => {
    setCart((prevCart) => {
      const isItemAlreadyInCart = prevCart.some(item => item.id === itemToAdd.id);
      if (isItemAlreadyInCart) {
        return prevCart; 
      }
      return [...prevCart, itemToAdd];
    });
  }, []);

  const removeFromCart = useCallback((itemIdToRemove) => {
    setCart((prevCart) => prevCart.filter(item => item.id !== itemIdToRemove));
  }, []);

  const clearCart = useCallback(() => {
    setCart([]);
  }, []);

  // --- OBJETO COM OS VALORES DO CONTEXTO ---
  const contextValue = {
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    vehicleQuery,
    setVehicleQuery,
  };

  // --- RENDERIZA O PROVEDOR ---
  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};